export default __webpack_public_path__ + "static/media/edit_white.ad390d60.svg";